import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './themeSlice';
import formReducer from './formSlice';
import languageReducer from './languageSlice';
import regionReducer from './regionSlice';

const store = configureStore({
  reducer: {
    theme: themeReducer,
    form: formReducer,
    language: languageReducer,
    region: regionReducer,
  },
});

export default store;